import { makeStyles } from '@/styles/v4/tss-react';

const useStyles = makeStyles({ name: 'EligibilityCheckForm' })(
  ({ breakpoints, spacing }) => ({
    root: {
      display: 'flex',
      flexDirection: 'column',
      gap: spacing(1),
      width: '100%',
    },
    form: {
      display: 'flex',
      flexDirection: 'column',
      gap: spacing(0),
      width: '100%',
      [breakpoints.up('md')]: {
        flexDirection: 'row',
        alignItems: 'flex-end',
      },
    },
    field: {
      flex: 1,
      minWidth: 0,
    },
    submitButton: {
      width: '100%',
      [breakpoints.up('md')]: {
        width: 'auto',
        flexShrink: 0,
      },
    },
    secondaryLink: {
      textAlign: 'center',
      textDecoration: 'underline',
      [breakpoints.up('md')]: {
        textAlign: 'left',
      },
    },
  })
);

export default useStyles;
